export default {
    getFeed() {
        return window.api.get("/feed");
    }
}